import { render, staticRenderFns } from "./ImageOptimizerImage.vue?vue&type=template&id=0df42e26&scoped=true&"
import script from "./ImageOptimizerImage.vue?vue&type=script&lang=js&"
export * from "./ImageOptimizerImage.vue?vue&type=script&lang=js&"
import style0 from "./ImageOptimizerImage.vue?vue&type=style&index=0&id=0df42e26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df42e26",
  null
  
)

export default component.exports